var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.865 14 14 10.865 14 7C14 3.13499 10.865 0 7 0C3.13499 0 0 3.13499 0 7C0 10.865 3.13499 14 7 14ZM6.49999 3.00001C6.49999 2.725 6.72499 2.49999 7 2.49999C7.27501 2.49999 7.50001 2.725 7.50001 3.00001V6.76001L9.81252 8.61001C10.0275 8.78251 10.0625 9.09749 9.89 9.3125C9.84332 9.37112 9.78399 9.41842 9.71646 9.45089C9.64892 9.48336 9.57492 9.50014 9.49999 9.49999C9.38999 9.49999 9.27998 9.46498 9.18751 9.38999L6.68752 7.39001C6.57002 7.295 6.50003 7.15251 6.50003 7V3.00001H6.49999Z",
    fill: "#B6BAC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.5c93d2bd7c827a1985e2f9ab2658d41c.svg";
export { ForwardRef as ReactComponent };